import { useEffect } from 'react';
import { FileText, Image, File, Loader, Trash2, Presentation, Table } from 'lucide-react';
import { useTaskPolling } from '../hooks/useTaskPolling';
import { deleteTask } from '../services/api';
import { formatFileSize, statusLabel, statusColor, getFileIcon } from '../utils/format';

const iconMap = {
  pdf: FileText,
  docx: FileText,
  xlsx: Table,
  pptx: Presentation,
  image: Image,
  file: File,
};

export default function TaskItem({ task, selected, onSelect, onTaskUpdate, onDelete }) {
  const needsPolling =
    task.status !== 'completed' && task.status !== 'failed';
  const { task: polledData } = useTaskPolling(needsPolling ? task.taskId : null);

  useEffect(() => {
    if (polledData) {
      onTaskUpdate(task.taskId, {
        status: polledData.status,
        progress: polledData.progress,
        result: polledData.result,
        quality_report: polledData.quality_report,
        error: polledData.error,
      });
    }
  }, [polledData, task.taskId, onTaskUpdate]);

  const handleDelete = async (e) => {
    e.stopPropagation();
    try {
      await deleteTask(task.taskId);
    } catch {
      /* ignore */
    }
    onDelete(task.taskId);
  };

  const iconType = getFileIcon(task.fileName);
  const IconComponent = iconMap[iconType] || File;
  const isActive = task.status === 'processing';

  return (
    <div
      className={`task-item ${selected ? 'selected' : ''}`}
      onClick={onSelect}
    >
      <div className={`task-icon ${iconType}`}>
        {isActive ? (
          <Loader size={20} className="spinner" />
        ) : (
          <IconComponent size={20} />
        )}
      </div>
      <div className="task-info">
        <div className="task-name">{task.fileName}</div>
        <div className="task-meta">
          <span className="task-id" title={task.taskId}>
            {task.taskId.substring(0, 8)}
          </span>
          <span>{formatFileSize(task.fileSize)}</span>
          {task.options?.lang && (
            <span className="task-lang">{task.options.lang.toUpperCase()}</span>
          )}
          {task.progress > 0 && task.status === 'processing' && (
            <span>{task.progress}%</span>
          )}
        </div>
        {isActive && (
          <div className="progress-bar-track">
            <div
              className="progress-bar-fill"
              style={{ width: `${task.progress || 0}%` }}
            />
          </div>
        )}
      </div>
      <span
        className="task-status-badge"
        style={{
          color: statusColor(task.status),
          background: statusColor(task.status) + '18',
        }}
      >
        {statusLabel(task.status)}
      </span>
      <button className="btn-icon" onClick={handleDelete} title="Supprimer">
        <Trash2 size={14} />
      </button>
    </div>
  );
}
